//comment
const BASE_URL = process.env.REACT_APP_API_BASE_URL_MOBILE;

export const API_ENDPOINTS = {
    GENERATE_OTP: `${BASE_URL}/auth/generate-otp`,
    VERIFY_OTP: `${BASE_URL}/auth/verify-otp`,

    GET_PORTS: `${BASE_URL}/charging-port/available-ports`,
    SELECT_PORT: `${BASE_URL}/charging-port/select-ports`,

    GET_TIME_OPTIONS: `${BASE_URL}/pricing-management/time-price-map`,
    POST_TIME_SELECTION: `${BASE_URL}/pricing-management/submit-pricing`,
    EXTRA_TIME_SELECTION: `${BASE_URL}/charging-port/extend-session`,

    PAYMENT_CONFIRMATION: `${BASE_URL}/razorpay/verify-payment`,

    TRANSACTION: `${BASE_URL}/transaction`,

};